import React from 'react';
import ProductMobile from './ProductMobile';
import ProductDesktop from './ProductDesktop';

/**
 * Thin router between two fully independent page implementations — ProductMobile.js and
 * ProductDesktop.js. They intentionally do not share layout JSX (each hardcodes its own
 * isMobileLayout), so editing one can never accidentally change the other. This file owns
 * nothing but the mobile/desktop decision.
 */
const Product = () => {
  const isMobileLayout = typeof window !== 'undefined' && window.innerWidth <= 768;
  return isMobileLayout ? <ProductMobile /> : <ProductDesktop />;
};

export default Product;
